<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Valores zavic</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="zavicFactorForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar valor</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Baja puntuación</label>
                                    <input formControlName="lowDesc" type="text"  class="form-control" placeholder="Baja puntuación">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Puntuación media</label>
                                    <input formControlName="midDesc" type="text"  class="form-control" placeholder="Puntuación media">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Alta puntuación</label>
                                    <input formControlName="highDesc" type="text"  class="form-control" placeholder="Alta puntuación">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Valor</label>
                                    <select formControlName="name" class="form-control custom-select">
                                        <option value="Moral">Moral</option>
                                        <option value="Legalidad">Legalidad</option>
                                        <option value="Indiferencia">Indiferencia</option>
                                        <option value="Corrupto">Corrupto</option>
                                        <option value="Economico">Economico</option>
                                        <option value="Politico">Político</option>
                                        <option value="Social">Social</option>
                                        <option value="Religioso">Religioso</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>